/*@flow*/

export default (ref: {| current: null | HTMLElement |}): ((val: string) => void) => (val: string) => {
  const { current } = ref;
  if (!current) return;
  const currentVal = current.style.display;
  if (currentVal === val) return;
  current.style.display = val;
};
